import { useState, Fragment } from 'react'

import useClipboard from 'Utils/hooks/useClipboard'

import ShowIcon from 'Icons/eye.svg'
import HideIcon from 'Icons/eye-slash.svg'
import CopyIcon from 'Icons/copy.svg'
import CopiedIcon from 'Icons/check.svg'

import styles from './APIToken.module.css'

export const TokenActions = (cellProps) => {
  const { value, isHovered } = cellProps
  const [isMasked, setIsMasked] = useState(false)
  const { copy, copied } = useClipboard()

  const maskedToken = value.token.slice(0, 4) + 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'
  const token = isMasked ? value.token : maskedToken

  return (
    <div className={styles.TokenContainer}>
      <div className={styles.Token}>{token}</div>
      {isHovered && (
        <Fragment>
          <span className={styles.ActionContainer} onClick={() => setIsMasked(!isMasked)}>
            {!isMasked && <ShowIcon />}
            {isMasked && <HideIcon />}
          </span>
          <span className={styles.CopyContainer} onClick={() => copy(value.token)}>
            {!copied && <CopyIcon />}
            {copied && <CopiedIcon />}
          </span>
        </Fragment>
      )}
    </div>
  )
}
